import { ImageIcon } from 'lucide-react'

import { resolveBackendUploadUrl } from '../resolveBackendUploadUrl'

const Thumbnail = ({ src, alt = '', className = 'h-10 w-10', rounded = 'rounded-lg', resolve = true }) => {
  const resolved = resolve ? resolveBackendUploadUrl(src) : src
  if (!resolved) {
    return (
      <div className={`grid ${className} ${rounded} place-items-center bg-brand-50 text-brand-300`}>
        <ImageIcon className="h-4 w-4" aria-hidden />
      </div>
    )
  }
  return <img src={resolved} alt={alt} className={`${className} ${rounded} object-cover`} />
}

export default Thumbnail
